<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12AgryO/tc-custom/9781504068772.jpg?1699984645354" alt="This image is the cover for the book Darling Buds of May, The Pop Larkin Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Darling Buds of May, The Pop Larkin Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The rich spirit of an English junk dealer and his family is challenged by the arrival of the tax collector in this humorous and heartwarming classic.</b><br/><br/> Beneath the sunny, cloudless skies of Kent, the Larkin household—Pop, Ma, and their six children—enjoy the simple pleasures of life. Pop works as a junk dealer and keeps the farm to feed his brood, while Ma cooks the meals and minds the children. While the family may not seem to have much, they more than make up for it in joyous spirit—and bountiful feasts.<br/><br/> All of that could change, however, when a stranger appears on their farm. Cedric Charlton from Inland Revenue has come to inquire why the Larkins failed to file income tax for the previous year. But Charlton’s plans hit a snag when the eldest Larkin daughter, Mariette, takes a liking to him—and he to her. Now, if the Larkins and country living can charm Charlton, perhaps he will forget about every last pound they owe . . .<br/><br/> “A pulsing comedy of country manners. A five-alarm blaze of a book. Just about <i>perfick</i>.” —<i>Time</i><br/><br/> “A gently, anarchic, wish-fulfilling daydream.” —<i>The Times </i>(London)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. E. Bates
      </h2>
      
      <p class="authorDescription body article">H. E. Bates was born in Northamptonshire, England, in 1905. Bates published his first novel, <I>The Two Sisters</I>, when he was twenty. His most popular creation was the effervescent Larkin family, about whom he wrote five novels, including <I>The Darling Buds of May</I>. In 1973, Bates was awarded a Commander of the Order of the British Empire (CBE). He died in 1974.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c3f8de7